<ol class="timeline">
	<li
		class="timeline__entry"
		*ngFor="let entry of entries; trackBy: trackByIndex"
	>
		<div class="timeline__when">
			<typography
				variant="p/xs_semibold"
				class="timeline__day"
				*ngIf="entry.day"
			>
				{{ entry.day }}
			</typography>
			<typography variant="p/xs_regular" class="timeline__time">
				{{ entry.time }}
			</typography>
		</div>

		<span
			class="timeline__dot"
			aria-hidden="true"
			[style.background]="accent"
		></span>

		<div class="timeline__what">
			<div class="timeline__head">
				<typography variant="p/sm_semibold" class="timeline__rule">
					{{ entry.rule }}
				</typography>
				<typography
					variant="p/xxs_semibold"
					class="timeline__fires"
					*ngIf="entry.fires"
				>
					{{ entry.fires }}
				</typography>
			</div>
			<typography variant="p/xs_regular" class="timeline__fired">
				{{ entry.fired }}
			</typography>
		</div>
	</li>
</ol>
